module.exports = __webpack_public_path__ + "img/docVector.3bfc2d8d.svg";